// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components-Button----button-module---button---1Tg9s","content":"src-components-Button----button-module---content---8YtCY","cardboardImg":"src-components-Button----button-module---cardboardImg---vLlTW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/button.module.scss
// module id = 341
// module chunks = 35783957827783